
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';


export class PingController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/ping');
    }
    
        keepAlive(owner:ISupportSpinner, success:{(res:boolean):any}, error?:AjaxError) {
    super._call('get', '', owner, null, null, success, error)
}
}
